import {
  UserRegistrationFormData,
  ContactsSectionFormData,
  SecondaryAddressSectionFormData,
  CertificationsSectionFormData,
  HolderSectionFormData,
  TechnicalDirectorFormData,
  TechnicalManagerFormData,
  PrimaryBankDetailsFormData,
  SecondaryBankDetailsFormData,
  PrivacyFormData,
  PersonHolderFormData,
  BankAccountFormData,
  CompanySectionFormData,
} from './formTypes'

const personHolderDefaultValues: PersonHolderFormData = {
  name: '',
  surname: '',
  fiscal_code: '',
  birth_date: null,
  birth_place: '',
  address_street: '',
  address_number: '',
  postal_code: '',
  province_id: '',
  city_id: '',
}

const personHolderEmptyValues = (): Record<keyof PersonHolderFormData, null> =>
  Object.fromEntries(
    Object.keys(personHolderDefaultValues).map((key) => [key, null])
  ) as Record<keyof PersonHolderFormData, null>

const bankAccountDefaultValues: BankAccountFormData = {
  bank: '',
  agency: '',
  iban: '',
  delegated_name: '',
  delegated_surname: '',
  delegated_fiscal_code: '',
  delegated_role: '',
}

const bankAccountEmptyValues = (): Record<keyof BankAccountFormData, null> =>
  Object.fromEntries(
    Object.keys(bankAccountDefaultValues).map((key) => [key, null])
  ) as Record<keyof BankAccountFormData, null>

const companySectionDefaultValues: CompanySectionFormData = {
  company_name: '',
  company_type: null,
  registration_type: null,
  company_fiscal_code: '',
  company_vat: '',
  company_activity: '',
  company_cciaa_nr: '',
  company_cciaa_date: null,
  company_date_start: null,
  company_minimum_tax: false,
  flat_rate_vat: false,
  company_withholding_tax: '',
}
const contactsSectionDefaultValues: ContactsSectionFormData = {
  company_address_street: '',
  company_address_number: '',
  company_postal_code: '',
  company_phone_number: '',
  company_mobile_number: '',
  company_fax_number: null,
  company_pec: '',
  company_province_id: '',
  company_city_id: '',
}
const secondaryAddressSectionDefaultValues: SecondaryAddressSectionFormData = {
  fill_company_secondary_address: false,
  company_secondary_address_street: null,
  company_secondary_address_number: null,
  company_secondary_postal_code: null,
  standard_iso_iec_27001: null,
  company_secondary_province_id: null,
  company_secondary_city_id: null,
}
const certificationsSectionDefaultValues: CertificationsSectionFormData = {
  company_dm_letters: null,
  standard_iso_9001: null,
  standard_iso_14001: null,
  standard_ohsas18001: null,
  standard_iso_45001: null,
  standard_iso_iec_27001: null,
  standard_sa8000: null,
  standard_other: null,
}

const holderSectionDefaultValues: HolderSectionFormData = {
  holder_address: { ...personHolderDefaultValues },
}

const technicalDirectorSectionDefaultValues: TechnicalDirectorFormData = {
  fill_technical_director: false,
  technical_director_address: { ...personHolderEmptyValues() },
}

const technicalManagerSectionDefaultValues: TechnicalManagerFormData = {
  fill_technical_manager: false,
  technical_manager_address: { ...personHolderEmptyValues() },
}

const primaryBankDetailsSectionDefaultValues: PrimaryBankDetailsFormData = {
  bank_account_1: { ...bankAccountDefaultValues },
}

const secondaryBankDetailsSectionDefaultValues: SecondaryBankDetailsFormData = {
  fill_secondary_bank_account: false,
  bank_account_2: { ...bankAccountEmptyValues() },
}

const privacySectionDefaultValues: PrivacyFormData = {
  privacy_required: false,
  privacy_optional_internal_marketing: null,
  privacy_optional_external_marketing: null,
}

export const userRegistrationDefaultValues: UserRegistrationFormData = {
  ...companySectionDefaultValues,
  ...contactsSectionDefaultValues,
  ...secondaryAddressSectionDefaultValues,
  ...certificationsSectionDefaultValues,
  ...holderSectionDefaultValues,
  ...technicalDirectorSectionDefaultValues,
  ...technicalManagerSectionDefaultValues,
  ...primaryBankDetailsSectionDefaultValues,
  ...secondaryBankDetailsSectionDefaultValues,
  ...privacySectionDefaultValues,
}
